var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "download_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27071",
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39524",
    clipPath: "url(#download_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17509",
    d: "M14.991 25.982c.036.032.073.063.112.092a1.5 1.5 0 00.9.3h.079a1.492 1.492 0 00.918-.382l6.5-5.806a1.5 1.5 0 10-2-2.237l-4 3.573V1.5a1.5 1.5 0 00-3 0v20.021l-4-3.573a1.5 1.5 0 00-2 2.237z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17510",
    d: "M30.5 29h-29a1.5 1.5 0 000 3h29a1.5 1.5 0 000-3"
  }))));
}
export default SvgDownload;